import {IRuleset} from '../../../index';
import {lm} from '../../../appContext';
import {getHash, isRoutePermissionOkay} from '../../../constants/RouteDefinitions';
import {nsRuleset} from '../nsRuleset';
import {IPageShellHeaderActions} from '../../page-shell/pageShellHeaderActions';

/** Ruleset actions for the page heading: preview/edit up front, copy and delete behind "Mer". */
export function buildRulesetActions(ruleset: IRuleset): IPageShellHeaderActions {
    const refs = nsRuleset.getRefsObjectWithoutReferenceToSubRulesets(ruleset);
    const isRulesetInUse = Object.keys(refs).length;

    return {
        quick: [
            {
                icon: 'fa-eye',
                label: 'preview',
                onClick: () => nsRuleset.fnPreviewRuleset(ruleset),
            },
            {
                icon: 'fa-pencil',
                label: 'edit',
                href: () => getHash('editruleset', {id: ruleset.id}) ?? '',
            },
        ],
        more: [
            {
                icon: 'fa-copy',
                label: 'copy',
                onClick: () => nsRuleset.copyDialog(ruleset),
                validator: () => isRoutePermissionOkay('createruleset'),
            },
            {
                cls: 'btn-destructive explicit',
                icon: 'fa-trash-alt',
                label: 'delete',
                description: () => lm.t('cannot delete subject, it is in use by other objects|subject:((ruleset|ac))') ?? '',
                onClick: () => nsRuleset.trashDialog(ruleset),
                enabled: () => isRoutePermissionOkay('createruleset') && !isRulesetInUse,
            },
        ],
    };
}
